import { type FC, memo } from 'react';
import { optionalProp } from '../core';
import { FAIcon } from '../Icons/Icons';
import { type CarouselButtonPropTypes } from './types/propTypes';
import styles from './Carousel.module.scss';

const CarouselButton: FC<CarouselButtonPropTypes> = ({
  id,
  icon,
  iconStyle,
  iconClass = '',
  clickHandler,
  ...restProps
}) => (
  <>
    <div
      role={'presentation'}
      id={id}
      onClick={clickHandler}
      className={`${styles['carousel-button']} ${iconClass}`}
      {...restProps}
    >
      <FAIcon {...optionalProp('iconName', icon)} {...optionalProp('iconStyle', iconStyle)} />
    </div>
  </>
);

export default memo(CarouselButton);
